import React, { useState } from 'react';
import { Icon } from '@ohif/ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const PanelSection = ({
  title,
  children,
  actionIcons = [],
  childrenClassName,
  isActive = false,
}) => {
  const [areChildrenVisible, setChildrenVisible] = useState(true);

  const handleHeaderClick = () => {
    setChildrenVisible(!areChildrenVisible);
  };

  return (
    <div className="rounded-[4px] overflow-hidden">
      {/* Header */}
      <div
        className={classnames(
          'flex h-7 select-none items-center cursor-pointer justify-between bg-[#d9d9d9] pl-2.5 text-[13px] mt-1',
          {
            'border rounded-[4px]': !areChildrenVisible,
            'border-t border-x rounded-t-[4px]': areChildrenVisible
          }
        )}
        onClick={handleHeaderClick}
      >
        <div className="font-semibold text-black">{title}</div>
        <div className="flex items-center space-x-1">
          {/* {actionIcons.map((icon, index) => (
            <Icon
              key={index}
              name={icon.name}
              onClick={e => {
                e.stopPropagation();
                if (!areChildrenVisible) {
                  setChildrenVisible(true);
                }
                icon.onClick();
              }}
              className="text-black"
            />
          ))} */}
          {/* <div className="grid h-[28px] w-[28px] place-items-center">
            <Icon
              name={areChildrenVisible ? 'chevron-down-new' : 'chevron-left-new'}
            />
          </div> */}
        </div>
      </div>

      {/* Body */}
      {areChildrenVisible && (
        <div
          className={classnames(
            'border-x border-b bg-white flex flex-col overflow-hidden rounded-b-[4px]',
            childrenClassName
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
};

PanelSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  childrenClassName: PropTypes.string,
  isActive: PropTypes.bool,
  actionIcons: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
};

export default PanelSection;
